import useSWR from 'swr'
import { fetchAppConfig, fetchNavConfig } from '@vt/apis/lib-ex/v2/apps'

export const useAppConfigSWR = (appId, token) => {
  const { data, mutate, error } = useSWR(['fetch-app-config', appId, token], {
    fetcher: () => fetchAppConfig(appId),
  })
  return {
    ProjectConfig: data || null,
    appConfigMutate: mutate,
    isAppConfigLoading: !error && !data,
    error,
  }
}

export const useNavConfigSWR = (appId) => {
  const { data, mutate, error } = useSWR(['fetch-nav-config', appId], {
    fetcher: () => fetchNavConfig(appId),
  })
  return {
    navSpec: data,
    navsMutate: mutate,
    isNavLoading: !error && !data,
    error,
  }
}
